// start:ng42.barrel
export * from './location.facade';
export * from './location.model';
// end:ng42.barrel

